module.exports = __webpack_public_path__ + "media/images/emblems/Zell-blazon-variant-2-4bbb47d13c39274e5b2167be7e48a8e0.svg";